import * as queryString from 'query-string';
import http from '../httpConfig';
import { AddPortPayload, AddBandwidthPayload } from '../interfaces/addPort.interface';
import { API_PATHS_NEW, ApiPath } from '../utils/apiConstants';
import { getAuthHeader } from '../utils/methods';

const getPortView = (portId: number) => {
  const url = queryString.stringifyUrl({ url: API_PATHS_NEW.portViewDetails, query: { portId } });
  return http.get(url, { headers: getAuthHeader() });
};

const portViewService = {
  getPortView,
};

export default portViewService;
